/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TCreateSubscriptionModel,
  ICreateSubscriptionRequest,
  IMappers,
  ICreateSubscriptionResponse,
  ICreateSubscriptionResponseError,
  TCreateSubscriptionResponse,
} from './types';

const defaultConfig: TCreateSubscriptionModel = {
  apiType: 'legacy',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'monolith-python',
  pathApi: '/cian-api/site/v1/create-subscription/',
  hostType: 'api',
} as TCreateSubscriptionModel;

function createCreateSubscriptionModel(parameters: ICreateSubscriptionRequest): TCreateSubscriptionModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ICreateSubscriptionOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: ICreateSubscriptionRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchCreateSubscription<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: ICreateSubscriptionOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TCreateSubscriptionResponse
> {
  const { response, statusCode } = await httpApi.fetch(createCreateSubscriptionModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICreateSubscriptionResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as ICreateSubscriptionResponseError);
    }
  }

  return { response, statusCode } as TCreateSubscriptionResponse;
}

export { defaultConfig, createCreateSubscriptionModel, fetchCreateSubscription };
